import { Col, Row } from "antd";
import React from "react";
import Zipcode from '../../../../../CommonComponents/Zipcode/Zipcode';
import regexMap from "../../../../../utils/regexMap";
import validate from "../../../../../utils/validations";
import { FormItemWrapper, InputWrapper, TitleMarginTop, TitleWrapper } from "../../../../NPA/Pages/Step1Setup/styles";
import { LabelWrapper, RowWrapper } from "../../Step1Setup/styles";
import { ErrMargin, ErrMarginZipCode, MainWrapper } from "../styles";
import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import { SelectComponentWrap } from "./Tabs/styles";

export default class AddressInfo extends React.Component {
  constructor(props) {
    super(props);       
    const state = props.addressData && props.addressData.state && props.addressData.country === "United States"
                  ? props.stateDropDown.find((i) => i.desc.trim() === props.addressData.state.trim()).value
                  : (props.addressData ? props.addressData.state: "");

    const country = props.countryDropDown.find((i) => {
      if(props.addressData && props.addressData.country !== "0") {
        return i.desc.trim() === props.addressData.country.trim();
      } else {
        return i.value === "0"
      }      
    }).value;
    
    this.state = {
      line1: {
        value: props.addressData ? props.addressData.line1 : "",
        touched: false,
        valid: "",
        validationRules: {
          isRequired: true,
          minLength: 2
        },
        messages: {
          isRequired: "Please enter address to continue.",
          minLength:
          "Address line 1 is too short. Please correct to proceed."
        }
      },
      line2: {
        value: props.addressData ? props.addressData.line2 : "",
        touched: false,
        valid: ""
      },
      line3: {
        value: props.addressData ? props.addressData.line3 : "",
        touched: false,
        valid: ""
      },
      zipcode: {
        value: props.addressData ? props.addressData.zip : "",
        touched: false,
        valid: "",
        validationRules: {
          isRequired: true,
          matchPattern: props.addressData
            ? this.regexValue(props.addressData.country)
            : ""
        },
        messages: {
          isRequired: "Please enter a zip code to continue",
          matchPattern:
            "Your zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue"
        }
      },
      city: {
        value: props.addressData ? props.addressData.city : "",
        touched: false,
        valid: "",
        matchPattern: regexMap.city,
        validationRules: {
          isRequired: true,
          minLength: 2
        },
        messages: {
          isRequired: "Please enter city continue.",
          minLength:
            "City is too short. Please correct to proceed."
        }
      },
      state: {
        value: state,
        touched: false,
        valid: "",
        matchPattern: regexMap.city,
        validationRules: {
          isRequired: true,
          minLength: 2
        },
        messages: {
          isRequired: "Please enter state to continue.",
          minLength: "State is too short. Please correct to proceed."
        }
      },
      country: {
        value: country,        
        touched: false,
        valid: "",
        validationRules: {
          isRequired: true
        },
        messages: {
          isRequired: "Please enter country to continue."
        }
      }
    };
  }


  componentDidMount() {
    this.handleFormChange();
  }

  componentWillReceiveProps(props) {    
    this.setState({
      line1: {
        ...this.state.line1,
        value: props.addressData ? props.addressData.line1 : "", 
      },
      line2: {
        value: props.addressData ? props.addressData.line2 : "",
        touched: true,
        valid: ""
      },
      line3: {
        value: props.addressData ? props.addressData.line3 : "",
        touched: true,
        valid: ""
      },
      zipcode: {
        ...this.state.zipcode,
        value: props.addressData ? props.addressData.zip : ""  
      },
      city: {
        ...this.state.city,
        value: props.addressData ? props.addressData.city : ""  
      },
      state: {
        ...this.state.state,
        value: props.addressData ? props.addressData.state : ""
      },
      country: {
        ...this.state.country,
        value: props.addressData ? props.addressData.country : ""
      }
    },()=>{
      if (props.validateForm) {
        this.runFormValidation();
      }
    });
    
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(prevProps.zipCodeData) !== JSON.stringify(this.props.zipCodeData) ) {
      this.state.state.value = this.state.country.value === "0" ?
          (this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] &&
          this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].hasOwnProperty('state') &&
          this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].state) ?
          this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].state :
          this.state.state.value || '' : '';
      
      this.state.state.touched = true;
      this.state.state.valid = "";
        
      this.state.city.value = (this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] &&
        this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].hasOwnProperty('city')) &&
        this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].city ?
        this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].city :
        this.state.city.value || '';

      this.state.city.touched = true;
      this.state.city.valid = "";
      this.handleFormChange();
      if (this.props.zipCodeData &&
          this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] &&
          this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].hasOwnProperty('zip') &&
          this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].zip === null &&
          this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].city === null &&
          this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].state === null) {
            this.state.city.value = '';
            this.state.state.value = '';
  
      }
    }
    if(this.props.legacyFormValid && prevProps.legacyFormValid !== this.props.legacyFormValid ){
        const updatedFormElement = {
            ...this.state
        };
        for (const inputIdentifier of Object.keys(updatedFormElement)) {
            if (updatedFormElement[inputIdentifier].validationRules 
                && Object.keys(updatedFormElement[inputIdentifier].validationRules).length) {
                    if(inputIdentifier === "zipcode"){
                      updatedFormElement[inputIdentifier].validationRules.matchPattern = regexMap.uszipCode
                    }
                    updatedFormElement[inputIdentifier].touched = false;
                }
        }        
        this.setState({
            ...updatedFormElement
        });
    }
    
  }
  regexValue = (country)=>{
   return  country === "0" || !country
    ? regexMap.uszipCode
    : regexMap.nonUSZipCode
  }
  runFormValidation = () => {
    const updatedFormElement = {
      ...this.state
    };
    for (const inputIdentifier of Object.keys(updatedFormElement)) {
      if (
        updatedFormElement[inputIdentifier].validationRules &&
        Object.keys(updatedFormElement[inputIdentifier].validationRules).length
      ) {

        if(inputIdentifier !== "state" || (inputIdentifier === "state" && this.state.country.value === "0")){
          updatedFormElement[inputIdentifier].valid = validate(
            updatedFormElement[inputIdentifier].value,
            updatedFormElement[inputIdentifier].validationRules
          );
          updatedFormElement[inputIdentifier].touched = true;
        }
       
      }
    }
    
    this.setState({
      ...updatedFormElement
    });
  };

  handleBlur = (event, field = '') => {
    const name = field ? field: event.target.name;
    let value =  field === 'state' ? event: event.target.value;
    value = value !== undefined && value !== null ? value: '';
    const updatedFormElement = {
      ...this.state[name]
    };
    updatedFormElement.valid = validate(
      value.trim(),
      updatedFormElement.validationRules
    );

    updatedFormElement.touched = true;

    this.setState({
      [name]: updatedFormElement
    });
  };

  // For text input
  handleInputChange = event => {
    const name = event.target.name;
    const value = event.target.value;

    const updatedFormElement = {
      ...this.state[name]
    };
    let matched = false;
    if (name === "zipcode") {
      let matchPattern = regexMap.zipcode;
      if(this.state.country.value !=="0"){
         matchPattern = regexMap.nonUSZipCode;
      }
      
      matched = matchPattern.test(value);
    } else {
      matched = updatedFormElement.matchPattern
        ? updatedFormElement.matchPattern.test(value)
        : true;
    }
    if (matched) {
      updatedFormElement.value = value.trimLeft();
      updatedFormElement.touched = true;
      updatedFormElement.valid = "";

      this.setState(
        {
          [name]: updatedFormElement
        }, () => {
          if (name === "zipcode" && matched) {
            this.state.zipcode.value = value.trimLeft();
          } else if (name === "city" && matched) {
            this.state.city.value = value.trimLeft();
          }
          this.handleFormChange()
        }
      );
    }
  };

  // For Select/Dropdowns
  handleSelectChange = (value, targetName, options) => {
    const name = targetName;

    let updatedFormElement = {
      ...this.state[name]
    };

    const state = {...this.state.state};
    const zipcode = {...this.state.zipcode};
    const city = {...this.state.city};
    const matched = options.filter(el => value === el.value);    
    if (matched.length) {
      if (name === "country") {
        zipcode.value= "";
        zipcode.valid= "";
        state.value= "";
        state.valid= ""
        city.value= "";
        city.valid= "";
        zipcode.validationRules.matchPattern = this.regexValue(value)
      }

      updatedFormElement.value = matched[0].value;
      updatedFormElement.touched = true;
      updatedFormElement.valid = "";

      this.setState(
        {
          zipcode,
          state,
          city,
          [name]: updatedFormElement,  
        }, () => {
          if (name === "country") {
            this.state.country.value = matched[0].value;
            this.state.state.value = '';
            this.state.zipcode.value = '';
          } else if (name === "state") {
            this.state.state.value = matched[0].value;
          }
          this.handleFormChange()
        }
      );
    }
  };

  checkFormValid = state => {
    let formIsValid = true;
    for (let inputIdentifier of Object.keys(state)) {
      if (
        state[inputIdentifier].validationRules &&
        Object.keys(state[inputIdentifier].validationRules).length
      ) {
        if(inputIdentifier !== "state" || (inputIdentifier === "state" && this.state.country.value === "0")){
          formIsValid =
          !validate(
            state[inputIdentifier].value,
            state[inputIdentifier].validationRules
          ) && formIsValid;
        }
        
      }
    }
    return formIsValid;
  };

  handleFormChange = () => {    
    this.props.handleFormChange(this.formatData());
  };

  formatData = () => {
    return {
      data: {
        address: {
          line1: this.state.line1.value,
          line2: this.state.line2.value,
          line3: this.state.line3.value,
          zip: this.state.zipcode.value,
          city: this.state.city.value,
          state: this.state.state.value,
          country: this.state.country.value
        }
      },
      isFormValid: this.checkFormValid(this.state)
    };
  };

  showError = elem => {
    return elem.touched && elem.valid;
  };

  render() {
    const { line1, line2, line3, zipcode, city, state, country } = this.state;       
    let data = this.props.stateDropDown;    
    return (
      <MainWrapper>
        <RowWrapper>
          <LabelWrapper>Address</LabelWrapper>
        </RowWrapper>
        <Row>
          <Col lg={{ span: 21 }} md={{ span: 16 }}>
            <InputComponent
              id={`txtLine1${this.props.successorKey}${this.props.contentKey}`}
              data-test="addressLine1"
              name="line1"
              handleBlur={this.handleBlur}
              title="Address line 1"
              placeholder="Enter address line 1"
              arialabel="Enter address line 1"
              handleInputChange={this.handleInputChange}
              value={line1.value}
              max={50}
            />
            {this.showError(line1) ? (
              <ErrMargin>{line1.messages[line1.valid]}</ErrMargin>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 21 }} md={{ span: 16 }}>
            <InputComponent
              id={`txtLine2${this.props.successorKey}${this.props.contentKey}`}
              data-test="addressLine2"
              name="line2"
              title="Address line 2 (Optional)"
              arialabel="Enter address line 2"
              placeholder="Enter address line 2"
              handleInputChange={this.handleInputChange}
              value={line2.value}
              max={50}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 21 }} md={{ span: 16 }}>
            <InputComponent
              id={`txtLine3${this.props.successorKey}${this.props.contentKey}`}
              name="line3"
              data-test="addressLine3"
              title="Address line 3 (Optional)"
              placeholder="Enter address line 3"
              arialabel="Enter address line 3"
              handleInputChange={this.handleInputChange}
              value={line3.value}
              max={50}
            />
          </Col>
        </Row>
        <Row  className="antRowFlex" type="flex">
          <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>Country</TitleWrapper>
                </TitleMarginTop>
              }
            >
              <SelectComponentWrap>
                <SelectComponent
                  name="country"
                  data-test="addressInfoCountry"
                  id={`country${this.props.successorKey}${
                    this.props.contentKey
                  }`}
                  title={'country'+ this.props.contentKey + this.props.successorKey}
                  showTitle={false}
                  placeholder="-Select-"
                  data={this.props.countryDropDown}
                  showArrow={true}
                  arialabel="Select Country"
                  handleInputChange={e =>{
                    this.props.resetAllZipCode('zipcode' + (this.props.contentKey + this.props.successorKey), 'country')
                    this.handleSelectChange(
                      e,
                      "country",
                      this.props.countryDropDown
                    )
                  }}
                  value={
                    this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] &&
                    this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].country ? this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].country : country.value
                  
                  }
                  disabled={this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] && this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].loading}
                />
                {this.showError(country) ? (
                  <ErrMargin>{country.messages[country.valid]}</ErrMargin>
                ) : null}
              </SelectComponentWrap>
            </FormItemWrapper>
          </Col>
          <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
          <FormItemWrapper
            colon={false}
            label={
              <TitleMarginTop>
                <TitleWrapper>Zip Code</TitleWrapper>
              </TitleMarginTop>
            }
          >
            <InputWrapper>
              <Zipcode
                id={`txtZipcode${this.props.successorKey}${this.props.contentKey}`}
                data-test="addressInfoZipcode"
                isUS={country.value === '0'}
                name='zipcode'
                ariaLabel='Enter zipcode'
                placeholder='Enter zipcode'
                title={'zipcode' + this.props.contentKey + this.props.successorKey}
                maxLength={country.value === '0' && '20'}
                onBlur={this.handleBlur}
                onChange={this.handleInputChange}
                value={zipcode.value}
              />
              {this.showError(zipcode) ? (
                <ErrMarginZipCode>{zipcode.messages[zipcode.valid]}</ErrMarginZipCode>
              ) : null}
            </InputWrapper>
          </FormItemWrapper>
        </Col>
          
          <Col lg={{ span: 10 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>City</TitleWrapper>
                </TitleMarginTop>
              }
            >
              <InputComponent
                name="city"
                data-test="addressInfoCity"
                id={`txtCity${this.props.successorKey}${this.props.contentKey}`}
                title={"city" + this.props.contentKey + this.props.successorKey}
                showTitle={false}
                placeholder="Enter city"
                arialabel="Enter city"
                handleBlur={this.handleBlur}
                handleInputChange={e => {
                  this.props.resetZipCode('zipcode' + (this.props.contentKey + this.props.successorKey), 'city')
                  this.handleInputChange(e)
                }}
                value={
                  this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] &&
                  this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].city ? this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].city : city.value
                }
                disabled={this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] && this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].loading}
                max={100}
              />
              {this.showError(city) ? (
                <ErrMargin>{city.messages[city.valid]}</ErrMargin>
              ) : null}
            </FormItemWrapper>
          </Col>
          {country.value === "0"?(
          <Col lg={{ span: 10 , offset: 1 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>State</TitleWrapper>
                </TitleMarginTop>
              }
            >
              <SelectComponentWrap>
                <SelectComponent
                  name="state"
                  data-test="addressInfoState"
                  id={`state${this.props.successorKey}${this.props.contentKey}`}
                  title={'state' + this.props.contentKey + this.props.successorKey}
                  showTitle={false}
                  arialabel="Select State"
                  placeholder="-Select-"
                  data={data}
                  showArrow={true}
                  handleBlur={ (e) => this.handleBlur(e, 'state')}
                  handleInputChange={e => {
                    this.props.resetZipCode('zipcode' + (this.props.contentKey + this.props.successorKey), 'state');
                    this.handleSelectChange(
                      e,
                      "state",
                      this.props.stateDropDown
                    )
                  }}
                  value={
                    this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] && 
                    this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].state ? this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].state : !!(state.value && state.value.trim()) ?  this.props.stateDropDown && state.value: undefined
                  }
                  disabled={this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)] && this.props.zipCodeData['zipcode' + (this.props.contentKey + this.props.successorKey)].loading}
                />
              </SelectComponentWrap>
            
              {this.showError(state) ? (
                <ErrMargin>{state.messages[state.valid]}</ErrMargin>
              ) : null}
            </FormItemWrapper>
          </Col>):null}

        </Row>
      </MainWrapper>
    );
  }
}
